

export class SimCardStatusOutput implements ISimCardStatusOutput {
    status!: number;
    message!: string;

    constructor(data?: ISimCardStatusOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SimCardStatusOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SimCardStatusOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        return data; 
    }
}

export interface ISimCardStatusOutput {
    status: number;
    message: string;
}

